import * as Api from '@ViewModels';
import { THEME } from '@Theme';
import { css } from 'aphrodite';
import { InternalMeetingNoteType } from '../../../../models/AdminModels';
import { AccountNote } from './AccountNote';
import { accountNotesSectionStyles as s } from './accountNotesSectionStyles';
import { OverviewCard } from './OverviewCard';

/** Accent color for the Notes card's ModuleTag header. */
const CARD_COLOR = THEME.colors.info.main;

export interface IAccountNotesSectionProps {
	/** The persisted account; passed straight through to each note. */
	account: Api.IAccount;
}

/**
 * Account Overview Notes section: Sales ("Summary from Sales"), Summary ("Summary from CSM"), and the latest CSM note —
 * each rendered by the no-MobX {@link AccountNote}. The CSM note carries the "Add a Note" /
 * "Add Meeting Notes" actions (gated inside `AccountNote` by `AnnotateAccount`). The card is
 * read-only chrome, so `OverviewCard` shows just the "Notes" header.
 */
export const AccountNotesSection = ({ account }: IAccountNotesSectionProps) => {
	return (
		<OverviewCard
			title='Notes'
			color={CARD_COLOR}
			canEdit={false}
			isEditMode={false}
			isSaving={false}
			onEdit={() => undefined}
			onSave={() => undefined}
			onCancel={() => undefined}
		>
			<div className={css(s.stack)}>
				{/* Legacy layout: Sales + CSM summary sit side by side; the latest CSM note spans below. */}
				<div className={css(s.pair)}>
					<div className={css(s.col)}>
						<AccountNote account={account} type={InternalMeetingNoteType.Sales} title='Summary from Sales' />
					</div>
					<div className={css(s.col)}>
						<AccountNote account={account} type={InternalMeetingNoteType.Summary} title='Summary from CSM' />
					</div>
				</div>
				<AccountNote account={account} type={InternalMeetingNoteType.CSM} title='Latest CSM Note' showAddActions />
			</div>
		</OverviewCard>
	);
};
